// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';
import { Moves, Offers } from '@gql/base-types';

import { Modal } from '@components/ModalComponents';
import AssignOrUnassignMoveModalContent from './AssignOrUnassignMoveModalContent';

// TYPES ---------------------------------------------------------------- //

interface AssignOrUnassignMoveModalProps {
  open: boolean;
  onClose?: (output?: any) => void;
  moveInput?: Moves | null;
  offersInput?: Offers[] | null;
}

// COMPONENT ---------------------------------------------------------------- //

const AssignOrUnassignMoveModal = ({ open, onClose, moveInput, offersInput }: AssignOrUnassignMoveModalProps) => {
  return (
    <Modal open={open}>
      {open && moveInput ? (
        <AssignOrUnassignMoveModalContent onClose={onClose} move={moveInput} offers={offersInput} />
      ) : null}
    </Modal>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default AssignOrUnassignMoveModal;
